import { IconProps } from "../../interfaces";

interface SupIconProps extends IconProps {
  onMouseEnter: (e: React.MouseEvent<HTMLOrSVGElement>) => void;
}

const SupLogo = ({ width, onMouseEnter, className }: SupIconProps) => {
  return (
    <svg
      onMouseEnter={onMouseEnter}
      width={width}
      height={width}
      viewBox="0 0 170 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        width="170"
        height="170"
        rx="40"
        fill="#424757"
      />
      <g clip-path="url(#clip0_2261_784)">
        <path
          d="M59.2175 69.7846L53.3472 63.9143C53.0354 63.6026 52.53 63.6026 52.2183 63.9143L46.348 69.7846C46.0362 70.0963 46.0362 70.6018 46.348 70.9135L52.2183 76.7838C52.53 77.0955 53.0354 77.0955 53.3472 76.7838L59.2175 70.9135C59.5292 70.6018 59.5292 70.0963 59.2175 69.7846Z"
          fill="#70FFBA"
        />
        <path
          d="M48.6312 85.1961C48.1903 85.1961 47.8329 84.8387 47.8329 84.3978V81.0452C47.8329 80.6043 47.4755 80.2469 47.0347 80.2469H41.8177H37.9346H32.7176C32.2767 80.2469 31.9194 79.8895 31.9194 79.4487V75.2977V71.1468C31.9194 70.7059 32.2767 70.3486 32.7176 70.3486H37.9346H41.8177H47.0347C47.4755 70.3486 47.8329 69.9912 47.8329 69.5503V61.2485C47.8329 60.8076 47.4755 60.4502 47.0347 60.4502H41.8177H37.9346H32.7176C32.2767 60.4502 31.9194 60.8076 31.9194 61.2485V64.6011C31.9194 65.042 31.562 65.3994 31.1211 65.3994H22.8193C22.3784 65.3994 22.021 65.7568 22.021 66.1976V70.3486V75.2977V80.2469V84.3978C22.021 84.8387 22.3784 85.1961 22.8193 85.1961H31.1211C31.562 85.1961 31.9194 85.5535 31.9194 85.9944V89.347C31.9194 89.7879 32.2767 90.1453 32.7176 90.1453H37.9346H41.8177H47.0347C47.4755 90.1453 47.8329 90.5027 47.8329 90.9435V95.0945V99.2454C47.8329 99.6862 47.4755 100.044 47.0347 100.044H41.8177H37.9346H32.7176C32.2767 100.044 31.9194 99.6862 31.9194 99.2454V95.8927C31.9194 95.4518 31.562 95.0945 31.1211 95.0945H22.8193C22.3784 95.0945 22.021 95.4518 22.021 95.8927V104.195C22.021 104.635 22.3784 104.993 22.8193 104.993H31.1211C31.562 104.993 31.9194 105.35 31.9194 105.791V109.144C31.9194 109.585 32.2767 109.942 32.7176 109.942H37.9346H41.8177H47.0347C47.4755 109.942 47.8329 109.585 47.8329 109.144V105.791C47.8329 105.35 48.1903 104.993 48.6312 104.993H56.933C57.3739 104.993 57.7313 104.635 57.7313 104.195V95.0945V85.9944C57.7313 85.5535 57.3739 85.1961 56.933 85.1961H48.6312Z"
          fill="white"
        />
        <path
          d="M150.436 69.7851L144.565 63.9148C144.254 63.6031 143.748 63.6031 143.437 63.9148L137.566 69.7851C137.254 70.0968 137.254 70.6023 137.566 70.914L143.437 76.7843C143.748 77.096 144.254 77.096 144.565 76.7843L150.436 70.914C150.747 70.6023 150.747 70.0968 150.436 69.7851Z"
          fill="#70CCFF"
        />
        <path
          d="M139.85 80.2469C139.41 80.2469 139.052 80.6043 139.052 81.0452V85.6294C139.052 86.0702 138.695 86.4276 138.254 86.4276H133.035H129.154H123.935C123.494 86.4276 123.137 86.0702 123.137 85.6294V80.2469V75.2977V71.1468C123.137 70.7059 123.494 70.3486 123.935 70.3486H129.154H133.035H138.254C138.695 70.3486 139.052 69.9912 139.052 69.5503V61.2485C139.052 60.8076 138.695 60.4502 138.254 60.4502H133.035H129.154H123.935C123.494 60.4502 123.137 60.8076 123.137 61.2485V64.6011C123.137 65.042 122.779 65.3994 122.338 65.3994H114.037C113.596 65.3994 113.238 65.7568 113.238 66.1976V70.3486V75.2977V80.2469V90.1453V100.044V109.144C113.238 109.585 113.596 109.942 114.037 109.942H122.338C122.779 109.942 123.137 109.585 123.137 109.144V100.044V97.1242C123.137 96.6834 123.494 96.326 123.935 96.326H129.154H133.035H138.254C138.695 96.326 139.052 95.9686 139.052 95.5277V90.9435C139.052 90.5027 139.41 90.1453 139.85 90.1453H148.152C148.593 90.1453 148.95 89.7879 148.95 89.347V81.0452C148.95 80.6043 148.593 80.2469 148.152 80.2469H139.85Z"
          fill="white"
        />
        <path
          d="M104.827 99.4787L98.957 93.6084C98.6453 93.2967 98.1399 93.2967 97.8281 93.6084L91.9578 99.4787C91.6461 99.7904 91.6461 100.296 91.9578 100.608L97.8281 106.478C98.1399 106.79 98.6453 106.79 98.957 106.478L104.827 100.608C105.139 100.296 105.139 99.7904 104.827 99.4787Z"
          fill="#70CCFF"
        />
        <path
          d="M94.2416 60.4504C93.8008 60.4504 93.4434 60.8078 93.4434 61.2487V70.3488V80.2472V89.3473C93.4434 89.7881 93.8008 90.1455 94.2416 90.1455H102.542C102.982 90.1455 103.34 89.7881 103.34 89.3473V80.2472V70.3488V61.2487C103.34 60.8078 102.982 60.4504 102.542 60.4504H94.2416Z"
          fill="white"
        />
        <path
          d="M83.5449 100.044H78.326C77.8851 100.044 77.5277 99.6862 77.5277 99.2454V95.0945V90.1453V80.2469V70.3486V61.2485C77.5277 60.8076 77.1704 60.4502 76.7295 60.4502H68.4276C67.9868 60.4502 67.6294 60.8076 67.6294 61.2485V70.3486V80.2469V90.1453V95.0945V100.044V104.195C67.6294 104.635 67.9868 104.993 68.4276 104.993H76.7295C77.1704 104.993 77.5277 105.35 77.5277 105.791V109.144C77.5277 109.585 77.8851 109.942 78.326 109.942H83.5449H87.4261H92.645C93.0859 109.942 93.4433 109.585 93.4433 109.144V100.842C93.4433 100.401 93.0859 100.044 92.645 100.044H87.4261H83.5449Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2261_784">
          <rect
            width="128.979"
            height="49.4918"
            fill="white"
            transform="translate(22.021 60.4502)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SupLogo;
